import { AxiosInstance } from "axios";

export const createUserAPI = async (api: AxiosInstance, formData: FormData) => {
  try {
    return await api.post(`/admin/users/create`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  } catch (error) {
    throw error;
  }
};


export const getUsersAPI = async (api: AxiosInstance) => {
  return api.get('/admin/users');
};

// export const updateUserAPI = async (api: AxiosInstance, data?: any) => {
//   return api.put(`/admin/users`, data);
// };

export const updateUserAPI = async (api: AxiosInstance, { id, formData }: { id: string, formData: FormData }) => {
  return api.put(`/admin/users/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};


export const deleteUserAPI = async (api: AxiosInstance, id: string) => {
  return api.delete(`/admin/users/${id}`);
};
